import React from 'react'
import commonStyles from '../addpayernew/AddPayerCommonStyles.styles'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import { HEADING } from '../../../components/heading/constants/constants'
import BasicCard from '../../../components/card/basiccard/BasicCard'
import Icons from '../../../components/icons/Icons'
import Heading from '../../../components/heading/Heading'
import Button from '../../../components/button/Button'
import { BUTTON_TYPE } from '../../../components/button/constants'

const PageInfoCard = ({ cardTitle = "",
    confirmationButtonProps = {
        onConfirmationCb: () => { },
        confirmationButtonText: ""
    } }) => {
    return (
        <>
            <div style={commonStyles.addPayerSuccessContainer}>
                <BasicCard alignItems="center">
                    <Icons familyName="vec" iconName={VEC_ICON_NAME.PAYER_ADDED_SUCCESS} />
                    <Heading type={HEADING.H3} customStyle={commonStyles.cardHeading}>{cardTitle}</Heading>
                    <div style={commonStyles.grayBorder}></div>
                    <label style={commonStyles.payerName}>
                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={confirmationButtonProps.onConfirmationCb}>{confirmationButtonProps.confirmationButtonText}</Button>
                    </label>
                </BasicCard>
            </div>

        </>
    )
}

export default PageInfoCard;
